import { viewSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListTableViewFilter";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
    `,
};
